module.exports = __webpack_public_path__ + "static/img/94.1becafc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/94.png
// module id = rnjh
// module chunks = 0